export const services = [
  {
    slug: 'ai-agent', number: '01', english: 'AI Agent Development', title: 'AIエージェント開発',
    summary: '考えるAIから、仕事を進めるAIへ。',
    description: '社内ナレッジや業務システムと連携し、情報検索・判断支援・業務実行を担うAIエージェントを開発。現場の業務フローに合わせて、使い続けられる仕組みを設計します。',
    tags: ['AIエージェント', 'RAG・ナレッジ連携', '業務システム連携'],
    offerings: ['業務に合わせたAIエージェントの設計・開発', '社内ドキュメントを活用した情報検索・回答生成', '外部ツール・既存システムとのAPI連携', '人による確認を組み込んだ実行フローの設計'],
    flow: ['業務とデータの整理', '小さく検証・評価', 'システム連携・実装', '運用と継続改善'],
  },
  {
    slug: 'ai-dx', number: '02', english: 'AI / DX Consulting', title: 'AI／DXコンサル',
    summary: '課題の整理から、実装と日々の改善まで。',
    description: 'AI活用の計画づくりから、社内システムの連携・自動化、情シス支援、運用改善まで。業務とIT環境を整理し、検証・導入・現場への定着を一貫して支援します。',
    tags: ['AI活用・業務改善', 'システム連携・自動化', '情シス・運用支援'],
    offerings: ['業務フローの可視化とAI・DXロードマップの策定', '実証実験（PoC）と効果の検証', '社内システムの連携・自動化と改善開発', '情シス・ヘルプデスク、端末・Web・サーバーの保守', '現場への導入・定着と継続的な運用改善'],
    flow: ['課題のヒアリング', '活用方針・優先順位の整理', '検証と導入', '定着・改善支援'],
  },
  {
    slug: 'ai-development', number: '03', english: 'AI & Product Engineering', title: 'AI・プロダクト開発',
    summary: 'アイデアを、使えるプロダクトに。',
    description: '生成AI・RAG・映像解析を活用したシステムからWeb・iOSアプリまで。ユーザー体験と運用を見据え、企画・設計から開発、リリース後の改善まで一貫して支援します。',
    tags: ['生成AI・RAG', '映像解析', 'Web・iOS'],
    offerings: ['生成AI・RAGを活用したアプリケーション開発', '映像解析・人物検知のシステム開発', 'Webシステム・iOSアプリの設計と開発', 'UI／UX設計からリリース後の保守・改善'],
    flow: ['企画・要件定義', '体験設計・プロトタイプ', '開発・検証', 'リリース・改善'],
  },
  {
    slug: 'network', number: '04', english: 'Infrastructure & Automation', title: 'インフラ・運用自動化',
    summary: '挑戦を支える、揺るがない基盤。',
    description: 'ネットワーク・サーバーの設計と構築、監視、運用保守まで。開発段階から自動化を前提に、事業の継続を支える安定した仕組みをつくります。',
    tags: ['ネットワーク・サーバー', '監視・可視化', '運用自動化'],
    offerings: ['ネットワーク・物理／仮想サーバーの設計・構築', '統合監視基盤と運用状況の可視化', '業務システム連携と運用作業の自動化', '運用保守と継続的な基盤改善'],
    flow: ['現状と要件の確認', '基盤・運用の設計', '構築・検証', '監視・運用保守'],
  },
];

export const products = [
  { name: 'スマートAI面接', category: 'AI INTERVIEW', image: '/images/redesign/interview.webp', alt: 'ノートパソコンでAI面接を利用するイメージ', description: 'AIによる面接から分析・評価レポートまで。採用担当者が、人を見極める時間に集中できる仕組みへ。', url: 'https://smart-mensetsu.com' },
  { name: 'AIスマートカメラ', category: 'COMPUTER VISION', image: '/images/redesign/camera.webp', alt: '店舗に設置されたカメラと来店客のイメージ', description: '既存カメラの映像を、判断に使えるデータへ。人流や行動の可視化を通じて、現場の改善を支援します。', url: 'https://ai-smartcam.com/' },
  { name: 'FRiCサイネージ', category: 'DIGITAL SIGNAGE', image: '/images/redesign/signage.webp', alt: '商業施設のデジタルサイネージのイメージ', description: 'さまざまなディスプレイへの配信を一括管理。場所と時間に合わせた情報発信を、もっと自由に。', url: '/contact?service=FRiCサイネージ' },
];

export const consultationTypes = [
  ...products.map(product => product.name),
  'テッククルー', '採用について', 'その他',
];
